import React, { useMemo } from "react";
import { Crown } from "lucide-react";
import { useLang } from "../i18n";

const COLORS = ["#FFC83D", "#FF63B5", "#27C9EE", "#9C42F5", "#48D276", "#268CEB"];

export default function LevelUpCelebration({ open, studentName, level, onClose }) {
  const { t, pick } = useLang();
  const confetti = useMemo(() => Array.from({ length: 28 }).map((_, i) => ({
    left: `${(i * 37) % 100}%`,
    delay: `${(i % 10) * 0.22}s`,
    duration: `${2.6 + (i % 5) * 0.4}s`,
    color: COLORS[i % COLORS.length],
    size: 7 + (i % 3) * 4,
    round: i % 2 === 0,
  })), []);
  if (!open || !level) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" role="dialog" aria-modal="true" data-testid="level-up-modal">
      <div className="absolute inset-0 bg-[#05051f]/88 backdrop-blur-md" />
      {confetti.map((c, i) => (
        <span key={i} aria-hidden="true" className="absolute top-0"
          style={{
            left: c.left, width: c.size, height: c.size, background: c.color,
            borderRadius: c.round ? "50%" : "2px",
            animation: `confetti-fall ${c.duration} linear ${c.delay} infinite`,
          }} />
      ))}
      <div className="magic-panel relative w-full max-w-md p-8 text-center animate-pop glow-gold">
        <Crown className="w-16 h-16 mx-auto text-[#FFC83D] animate-floaty" fill="currentColor"
          style={{ filter: "drop-shadow(0 0 18px rgba(255,200,61,0.8))" }} />
        <h3 className="text-3xl font-black mt-4 bg-gradient-to-r from-[#FFC83D] to-[#FF63B5] bg-clip-text text-transparent">
          {t("celebration.congrats", { name: studentName })}
        </h3>
        {level.icon && (
          <img src={level.icon} alt={pick(level, "name")} className="w-28 h-28 rounded-full object-cover mx-auto mt-5 ring-4 animate-pulse-glow" style={{ ringColor: level.color }} />
        )}
        <p className="text-xl font-extrabold mt-4" style={{ color: level.color || "#FFC83D" }}>
          {t("celebration.reached", { level: pick(level, "name") })}
        </p>
        <button data-testid="level-up-view-btn" onClick={onClose} className="btn-magic btn-gold mt-6 w-full">
          {t("celebration.view")}
        </button>
      </div>
    </div>
  );
}
